import axios from 'axios';

export default {
  translate: (data) => axios.post('/api/v1/translate', data),
};
